import React, { useState } from 'react';
import './App.css';
import Aboutu from './Components/Aboutu';
import Contact from './Components/Contact';
import Education1 from './Components/Education1';
import Footer from './Components/Footer';
import Header from './Components/Header';
import Home1 from './Components/Home1';
import Skill1 from './Components/Skill1';
import Work from './Components/Work';
import Interfa from './Components/Interfa';
function App() {
  const [a, seta] = useState(true)
  function laod() {
    seta(false)
  }
  setTimeout(laod,3000)
  return (
    <div className="App">
     {a?<Interfa/>:<><Header/>
     <div className='main'>
      <Home1/>
      <Aboutu/>
      <Education1/>
      <Skill1/>
      <Work/>
      <Contact/>
      <Footer/>
     </div></>}
    </div>
  );
}


export default App;
